var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraduation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 16L3.11201 12.4111V7.07773L0 5.33333L9.5 0L19 5.33333V12.3604H17.9353V5.95185L15.888 7.07773V12.4111L9.5 16ZM9.5 9.40542L16.7717 5.33333L9.5 1.26125L2.22834 5.33333L9.5 9.40542ZM9.5 14.7454L14.8233 11.7738V7.68304L9.5 10.6634L4.17668 7.68304V11.7738L9.5 14.7454Z",
    fill: "#939393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduation);
export default __webpack_public_path__ + "static/media/graduation.cb2bd7c9597f59e6128838078b1152ec.svg";
export { ForwardRef as ReactComponent };